"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Point = _interopRequireDefault(require("./Point"));

var _Polygon2 = _interopRequireDefault(require("./Polygon"));

var _isNumber = _interopRequireDefault(require("../../utils/numbers/isNumber"));

var _isNotNumber = _interopRequireDefault(require("../../utils/numbers/isNotNumber"));

var _isEmpty = _interopRequireDefault(require("../../utils/array/isEmpty"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Rectangle = /*#__PURE__*/function (_Polygon) {
  (0, _inherits2["default"])(Rectangle, _Polygon);

  var _super = _createSuper(Rectangle);

  /** @private {number} */

  /** @private {number} */

  /** @private {number} */

  /** @private {number} (Center X) */

  /** @private {number} (Center Y) */

  /**
   * @param {number} centerX
   * @param {number} centerY
   * @param {number} width
   * @param {number} height
   * @param {number} rotationInDegrees
   */
  function Rectangle(centerX, centerY, width, height) {
    var _this;

    var rotationInDegrees = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    (0, _classCallCheck2["default"])(this, Rectangle);
    _this = _super.call(this, Rectangle.getVertices(centerX, centerY, width, height, rotationInDegrees));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_height", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_rotationInDegrees", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_width", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_x", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_y", void 0);
    _this._height = height;
    _this._rotationInDegrees = rotationInDegrees;
    _this._width = width;
    _this._x = centerX;
    _this._y = centerY;
    return _this;
  }

  (0, _createClass2["default"])(Rectangle, [{
    key: "copy",
    value: function copy() {
      return new Rectangle(this.x, this.y, this.width, this.height, this.rotationInDegrees);
    }
  }, {
    key: "equals",
    value: function equals(otherRectangle) {
      if (otherRectangle === this) return true;
      if (!Rectangle.isRectangle(otherRectangle)) return false;
      return this.x === otherRectangle.x && this.y === otherRectangle.y && this.height === otherRectangle.height && this.width === otherRectangle.width && this.rotationInDegrees === otherRectangle.rotationInDegrees;
    }
    /**
     * Returns offset from a given container rectangle
     * @param {!Rectangle} containerRectangle
     * @returns {number}
     */

  }, {
    key: "getOffsetsFrom",
    value: function getOffsetsFrom(containerRectangle) {
      if (!Rectangle.isValidRectangle(this) || !Rectangle.isValidRectangle(containerRectangle)) {
        throw new Error('Must provide valid Rectangles');
      }

      return {
        bottom: this.extrema.bottom - containerRectangle.extrema.bottom,
        left: this.extrema.left - containerRectangle.extrema.left,
        right: this.extrema.right - containerRectangle.extrema.right,
        top: this.extrema.top - containerRectangle.extrema.top
      };
    }
    /**
     * Returns the scale at which this rectangle would cover the given containerRectangle.
     * @param {!Rectangle} containerRectangle
     * @returns {number}
     */

  }, {
    key: "getScaleToFillIn",
    value: function getScaleToFillIn(containerRectangle) {
      if (!Rectangle.isValidRectangle(this) || !Rectangle.isValidRectangle(containerRectangle)) return 1; // Doesn't matter, because nothing will ever fit in a flat box.

      var containerHeight = containerRectangle.height,
          containerWidth = containerRectangle.width;
      if (this.width === 0 || this.height === 0 || containerWidth === 0 || containerHeight === 0) return 1;
      var widthRatio = containerRectangle.width / this.width;
      var heightRatio = containerRectangle.height / this.height;
      return Math.max(widthRatio, heightRatio);
    }
    /**
     * Returns the scale at which this rectangle would fit snugly inside given containerRectangle.
     * @param {!Rectangle} containerRectangle
     * @returns {number}
     */

  }, {
    key: "getScaleToFitIn",
    value: function getScaleToFitIn(containerRectangle) {
      if (!Rectangle.isValidRectangle(this) || !Rectangle.isValidRectangle(containerRectangle)) return 1;
      var containerHeight = containerRectangle.height,
          containerWidth = containerRectangle.width;
      if (this.width === 0 || this.height === 0 || containerWidth === 0 || containerHeight === 0) return 1;
      var widthRatio = containerRectangle.width / this.width;
      var heightRatio = containerRectangle.height / this.height;
      return Math.min(widthRatio, heightRatio);
    }
    /**
     * Scales the width and height of the rectangle to width * proportion and height * proportion
     * @param {number} proportion - A scalar value
     * @returns {Rectangle}
     */

  }, {
    key: "scale",
    value: function scale(proportion) {
      if (!proportion || proportion < 0) {
        return new Rectangle(this.x, this.y, this.width, this.height, this.rotationInDegrees);
      }

      return new Rectangle(this.x, this.y, this.width * proportion, this.height * proportion, this.rotationInDegrees);
    }
    /**
     * Scales the width and height of the rectangle to width * scaleX and height * scaleY
     * @param {number} scaleX
     * @param {number} scaleY
     * @returns {Rectangle}
     */

  }, {
    key: "asymmetricalScale",
    value: function asymmetricalScale(scaleX, scaleY) {
      if ((0, _isNotNumber["default"])(scaleX) || (0, _isNotNumber["default"])(scaleY)) {
        return new Rectangle(this.x, this.y, this.width, this.height, this.rotationInDegrees);
      }

      return new Rectangle(this.x, this.y, this.width * scaleX, this.height * scaleY, this.rotationInDegrees);
    }
    /**
     * Scales the rectangle to fill inside the containerRectangle
     * @param {!Rectangle} containerRectangle
     * @returns {Rectangle}
     */

  }, {
    key: "scaleToFill",
    value: function scaleToFill(containerRectangle) {
      var proportion = this.getScaleToFillIn(containerRectangle);
      return this.scale(proportion);
    }
    /**
     * Scales the rectangle to fit inside the containerRectangle
     * @param {!Rectangle} containerRectangle
     * @returns {Rectangle}
     */

  }, {
    key: "scaleToFit",
    value: function scaleToFit(containerRectangle) {
      var proportion = this.getScaleToFitIn(containerRectangle);
      return this.scale(proportion);
    } // @todo(chuti) fix to become static methods

  }, {
    key: "moveTo",
    value: function moveTo(point) {
      return new Rectangle(point.x, point.y, this.width, this.height, this.rotationInDegrees);
    }
  }, {
    key: "move",
    value: function move(moveX, moveY) {
      return new Rectangle(this.x + moveX, this.y + moveY, this.width, this.height, this.rotationInDegrees);
    }
    /**
     * @function getTranslationToFillRect
     * @param  {Rectangle} containerRect
     * @return {Point} Translation that should be done on current Rectangle to try to fill it inside containerRect
     */

  }, {
    key: "getTranslationToFillRect",
    value: function getTranslationToFillRect(containerRect) {
      var horizontalDelta = (this.width - containerRect.width) / 2;
      var maxTranslationX = horizontalDelta + containerRect.x;
      var minTranslationX = -horizontalDelta + containerRect.x;
      var verticalDelta = (this.height - containerRect.height) / 2;
      var maxTranslationY = verticalDelta + containerRect.y;
      var minTranslationY = -verticalDelta + containerRect.y;
      var constrainedX = Math.max(minTranslationX, Math.min(maxTranslationX, this.x));
      var constrainedY = Math.max(minTranslationY, Math.min(maxTranslationY, this.y));
      return new _Point["default"](constrainedX, constrainedY);
    }
    /**
     * Checks if object is an instance of Rectangle
     *
     * @param inputObject
     * @returns {boolean}
     */

  }, {
    key: "center",
    get: function get() {
      return new _Point["default"](this._x, this._y);
    }
    /** @returns {number} */

  }, {
    key: "height",
    get: function get() {
      return this._height;
    }
    /** @returns {number} */

  }, {
    key: "rotationInDegrees",
    get: function get() {
      return this._rotationInDegrees;
    }
    /** @returns {number} */

  }, {
    key: "width",
    get: function get() {
      return this._width;
    }
    /** @returns {number} */

  }, {
    key: "x",
    get: function get() {
      return this._x;
    }
    /** @returns {number} */

  }, {
    key: "y",
    get: function get() {
      return this._y;
    }
    /**
     * Numbers representing the sides (extreme points aka "extrema") of an unrotated rectangle.
     * @returns {{top: number, bottom: number, left: number, right: number}}
     */

  }, {
    key: "extrema",
    get: function get() {
      var _this$center = this.center,
          x = _this$center.x,
          y = _this$center.y;
      var halfW = this.width / 2;
      var halfH = this.height / 2;
      return {
        top: y - halfH,
        bottom: y + halfH,
        left: x - halfW,
        right: x + halfW
      };
    }
  }], [{
    key: "isRectangle",
    value: function isRectangle(inputObject) {
      return inputObject instanceof Rectangle;
    }
    /**
     * Checks if object is an instance of Rectangle and has valid center and height/width
     *
     * @param inputObject
     * @returns {boolean}
     */

  }, {
    key: "isValidRectangle",
    value: function isValidRectangle(inputObject) {
      return Rectangle.isRectangle(inputObject) && (0, _isNumber["default"])(inputObject.x) && (0, _isNumber["default"])(inputObject.y) && (0, _isNumber["default"])(inputObject.height) && (0, _isNumber["default"])(inputObject.width);
    }
    /**
     * @param {!Array<!Vector>} listOfPoints
     * @returns {!Rectangle}
     */

  }, {
    key: "getMinimumBoundingRectangleFromPoints",
    value: function getMinimumBoundingRectangleFromPoints(listOfPoints) {
      /** @type {number} */
      var minX = Number.POSITIVE_INFINITY;
      /** @type {number} */

      var minY = Number.POSITIVE_INFINITY;
      /** @type {number} */

      var maxX = Number.NEGATIVE_INFINITY;
      /** @type {number} */

      var maxY = Number.NEGATIVE_INFINITY;
      if ((0, _isEmpty["default"])(listOfPoints)) return undefined;
      listOfPoints.forEach(function (point) {
        var x = point.x,
            y = point.y;
        minX = Math.min(x, minX);
        minY = Math.min(y, minY);
        maxX = Math.max(x, maxX);
        maxY = Math.max(y, maxY);
      });
      /** @type {number} */

      var width = maxX - minX;
      /** @type {number} */

      var centerX = minX + width / 2;
      /** @type {number} */

      var height = maxY - minY;
      /** @type {number} */

      var centerY = minY + height / 2;
      return new Rectangle(centerX, centerY, width, height, 0);
    }
    /**
     * @param {number} centerX
     * @param {number} centerY
     * @param {number} width
     * @param {number} height
     * @param {number} rotationInDegrees
     * @returns {!Array<!Point>}
     */

  }, {
    key: "getVertices",
    value: function getVertices(centerX, centerY, width, height, rotationInDegrees) {
      var centerPoint = new _Point["default"](centerX, centerY);
      var halfW = width / 2;
      var halfH = height / 2;
      var topLeft = new _Point["default"](centerX - halfW, centerY - halfH);
      var topRight = new _Point["default"](centerX + halfW, centerY - halfH);
      var bottomLeft = new _Point["default"](centerX - halfW, centerY + halfH);
      var bottomRight = new _Point["default"](centerX + halfW, centerY + halfH);
      topLeft.rotateAroundPoint(centerPoint, rotationInDegrees);
      topRight.rotateAroundPoint(centerPoint, rotationInDegrees);
      bottomLeft.rotateAroundPoint(centerPoint, rotationInDegrees);
      bottomRight.rotateAroundPoint(centerPoint, rotationInDegrees);
      return [topLeft, topRight, bottomLeft, bottomRight];
    }
  }]);
  return Rectangle;
}(_Polygon2["default"]);

exports["default"] = Rectangle;